document.documentElement.style.setProperty("--brand-color", "#3ab7bf");

import { createRoot } from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import router from "./router.tsx";

// Initialize i18n
import "./lib/i18n";

window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(
  <RouterProvider router={router} />,
);
